module.exports = __webpack_public_path__ + "img/Icon_Abschaetzen.9c70adb6.svg";